/**
 * Публичный origin стенда для CTA и демо-ссылок лендинга.
 * Попадает в бандл на сборке; не использовать для секретов бэкенда.
 */
export const publicOrigin = import.meta.env.VITE_PUBLIC_ORIGIN ?? '';

/** Имя демо-пользователя, показываемое на лендинге. */
export const demoUsername = import.meta.env.VITE_DEMO_USERNAME ?? 'admin';

/** Публичный демо-пароль стенда (Vite inlines; не секрет БД). */
export const demoPassword = import.meta.env.VITE_DEMO_PASSWORD ?? '';
